export const localeTexts = {
  en: {
   gira: {
      programacion: 'Programming',
      calendario: 'Calendar',
      publicaciones: 'Publications',
      tvTour: 'On TV',
      onlineTour: 'Online Tour'
    },
    navbar: {
      nosotros: { label: "About Us" },
      programas: { label: "Initiatives" },
      calendario: { label: "Calendar" },
      películas: { label: "Films" },
      blog: { label: "Blog" },
      aliados: { label: "Partnerships" }
    },
    search: {
      viewAllResults: "View all results",
      noResults: "No films containing '{{query}}'",
      tryAgain: "Try another search term",
      placeholder: "Search films by title or director",
      placeHolderPublicaciones:"Search publications by title or author",
    },
    equipo:{
      team:"Team",
      share:"Share",
    },
    initiatives: {
      gira: {
        title: "Film Festival",
        description: "Our itinerant Film Festival"
      },
      presenta: {
        title: "Ambulante Presenta",
        description: "Documentary exhibition circuit based on collaborative work"
      },
      'mas-alla':{
        title:"Ambulante Más allá",
        description:"Documentary production training",
      },
       ediciones: {
        title:"Ambulante Publishing",
        description:"Titles to expand film culture",
      },
      vivero: {
        title: "Vivero",
        description: "Training in audiovisual documentary practices.",
        convocatoria: "Convocatory",
        quotesTitle:"test",
        quotesSubtitle:"test subtitle",
        editionsTitle:"Editions",
        catalogue: "Catalogue",
      },
    common: {  
      seeAllPrograms: "See all programs",
      now: "Now",
      allPrograms: "All programs",
      programsSection: "By programs",
	  programasAmbulante: "Ambulante Programs",
    },
  },
  breadcrumbs: {
    Home: "Home",
    blog: "Blog",
    catalog:"Catalog",
    programs: "Programs",
    catalog: "Catalog",
    initiatives: "Initiatives",
    },
  common:{
    sobre:"About",
    about: "About",
    viewAll: "View all",
    readMore: "Read more",
    back:"Back",
    seeAllPrograms: "See all programs",
    now: "Now",
    allPrograms: "All programs",
    programsSection: "By programs",
    contraloria:"Social Oversight",
    vacantes:"Vacancies",
    prensa:"Press",
    year: "Year",
    country: "Country",
    tourEditions: "Tour Editions",
    sections: "Sections",
    generations: "Generations",
    apEditions: "AP Editions",
    productionYear: "Production Year",
    allPrograms: "All Programs",
    documentaryTour: "Documentary Tour",
    ambulanteBeyond: "Ambulante Beyond",
    searchFilters: "Search filters",
    clear: "Clear",
    applyFilters: "Apply filters",
    filters: "Filters",
    programs: "Programs",
    about: "Sobre",
    viewAll: "Ver todas",
    viewDetails:"View Details",
    viewMoreDetails:" View More Details",
    generationsAndDocumentaries: "Generations and their documentaries",
    directedBy: "Directed by:",
    createdBy: "Created by:",
    viewAmaCollection: "View the entire AMA collection",
    behindTheScenes: "Behind the Scenes",
    theExperience: "The experience",
    beyondTheDocumentary: "Beyond the documentary",
    applyNow: "Apply now",
    downloadCatalog: "Download catalog",
    subscribe: "Subscribe",
    noSpam: "We won't send you SPAM, just news about upcoming calls for entries",
    faq: "Frequently Asked Questions",
    quotationMarks: "Quotation marks",
  },
  footer: {
      forYou: "FOR YOU",
      movies: "Films",
      calendar: "Calendar",
      pressCenter: "Press Center",
      programs: "PROGRAMS",
      tour: "Film Festival",
      beyond: "Ambulante Más Allá",
      presents: "Ambulante Presenta",
      editions: "Ambulante Publishing",
      information: "INFORMATION",
      directory: "Directory",
      privacy: "Privacy Notice",
      socialControl: "Social Control",
      vacancies: "Careers",
      contact: "Contact Us",
      newsletter: "Subscribe to newsletter",
      address: "Zacatecas 142-A, Roma Norte, Cuauhtémoc, 06700, Mexico City",
      copyright: "© 2024 Ambulante. All rights reserved"
    },
    movies: {
      about: "About",
      viewAll: "View all"
    },
    Aliados:{
      navigationAliados:"Sponsors Archive - Ambulante",
      title:" Partnerships",
      estado:"State",
      programas:"Programs",
      clearFilters: "Clear filters",
    },
     AmbulanteEdiciones: {
      navigationEdiciones: "Ambulante Publishing",
      title:"Ambulante Publishing",
      libros: "Books",
      Book: {
        publishedIn: "Published in",
        authors: "Author(s)",
        synopsis: "Synopsis",
        makeOrder: "Make order"
      },
      Magazine: {
        title: "Ambulante, the magazine",
        download: "Download issue",
      }
    },
    AmbulanteMasAlla: {
      navigationMasAlla: " Ambulante Más Allá",
      announcementBanner: "Want to be part of the 8th generation of Mobile Beyond?  🎥",
      announcementBannerSub: "🎬 Find out more!",
      proyecta: "Project documentaries of ",
      vimeo: "We recommend watching trailers in our Vimeo channel",
      write: "And write us at",
    },
    AmbulantePresenta: {
      titleSeo: "Ambulante Presents - Ambulante",
      title: "Ambulante Presents",
      materialesDescargables: "Downloadable Materials AP 2025",
      materialesDescargablesAnt:"Past Editions Downloadable Materials",
      testimonialsTitle: "The documentary cinema",
      testimonialsSubtitle: "at the reach of everyone",
    },
    Partners: {
      textHeadline: "Thank you",
      textHeadline2: "to our partners!",
    },
    GiraDocumentales: {
      breadcrumbs: "Film festival",
      historico: "History of scheduled films",
      buttonCatalogo: "See catalogue",
      testimonials: {
        title: "An exciting and",
        subtitle: "significant event",
      },
    },
    RelatedContent: {
      title: "Related content",
      AnchorChip: {
        publications: "Publications",
        films: "Films",
        screenings: "Screenings",
        events: "Events",
      },
      Blogposter:{
        note:"Note",
        news:"News",
    },
  },
    FeaturedTitleCustom: {
      Button:"See details",
    },
    Films:{
      today:"Exhibiting today",
      calendario:"Go to calendar"
    },
    Cards:{
      post:"Go to the post",
    },
    Peditions: {
      pastEditions: "Past Editions",
      downloadPrograms: "Download Programs",
      seeFilmCatalogue: "See Film Catalogue",
    },
    atras: "← Back",
    inicio: "Home",
    programas: "Programs",
    por: "By",
    volver: "Back to Top",
    sinopsis: "Synopsis",
    semblanza: "Overview",
    festivales: "Festivals and Awards",
    duracion: "Length",
    paises: "Countries",
    ano: "Year",
    idiomas: "Languages",
    direccion: "Director",
    tematicas: "Themes",
    iniciativas: "Initiatives",
    Mcreditos: "Show Credits",
    Ocreditos: "Close Credits",
    descargas: "Downloads",
    vtrailer: "Watch Trailer",
    nuestrosP: "Our Programs",
    mision: "Our mission is to mobilize spaces for collective encounter and action to build other worlds through documentary. Learn how we do it.",
    expMT: "Discover the films that have been shown at Ambulante",
    expMSub: "Explore by themes, years, countries and more",
    btnExpC: "Explore the catalog",
    gira: "Tour",
    aboutus: "About Us",
    compartir: "Share",
    movieCatalogT: "Explore the titles that have been part of Ambulante.",
    verTodasPeliculas: " View all movies",
    searchResults: "Search results",
    blog:{
      theme:"Theme",
      publicationType:"Type of publication",
      news:"News",
      viewAll:"View all",
      reviews:"Reviews",
      note:"Note",
      clearFilters:"Clear filters",
      viewAllPublications:"View all publications",
      searchResults:"Search Results",
      previous:"Previous",
      next:"Next",
      backToTop:"Back to top",
    },
    filter:{
      searchFilter:"Search filter",
      clear:"Clear",
    },
    calendar: {
      back: "← Back",
      home: "Home",
      calendar: "Calendar",
      today: "Today",
      eventsIn: "Events in ",
      filterBy: "Filter by:",
      states: "States",
      eventType: "Event Type",
      clearFilters: "Clear filters",
      backToTop: "Back to top",
      filters: "Filters",
      searchEvents: "Search events",
      projection: "Screening",
      onlineTour: "Online Tour",
      tvScreening: "TV Screening",
      noState: "No State",
      months: [
        { id: 0, name: "January", short: "Jan" },
        { id: 1, name: "February", short: "Feb" },
        { id: 2, name: "March", short: "Mar" },
        { id: 3, name: "April", short: "Apr" },
        { id: 4, name: "May", short: "May" },
        { id: 5, name: "June", short: "Jun" },
        { id: 6, name: "July", short: "Jul" },
        { id: 7, name: "August", short: "Aug" },
        { id: 8, name: "September", short: "Sep" },
        { id: 9, name: "October", short: "Oct" },
        { id: 10, name: "November", short: "Nov" },
        { id: 11, name: "December", short: "Dec" },
      ],
      mexicanStates: [
        { id: 0, name: "Aguascalientes", short: "Ags" },
        { id: 1, name: "Baja California", short: "BC" },
        { id: 2, name: "Baja California Sur", short: "BCS" },
        { id: 3, name: "Campeche", short: "Camp" },
        { id: 4, name: "Chiapas", short: "Chia" },
        { id: 5, name: "Chihuahua", short: "Chih" },
        { id: 6, name: "Ciudad de México", short: "CDMX" },
        { id: 7, name: "Coahuila", short: "Coah" },
        { id: 8, name: "Colima", short: "Col" },
        { id: 9, name: "Durango", short: "Dgo" },
        { id: 10, name: "Estado de México", short: "EdoMex" },
        { id: 11, name: "Guanajuato", short: "Gto" },
        { id: 12, name: "Guerrero", short: "Gro" },
        { id: 13, name: "Hidalgo", short: "Hgo" },
        { id: 14, name: "Jalisco", short: "Jal" },
        { id: 15, name: "Michoacán", short: "Mich" },
        { id: 16, name: "Morelos", short: "Mor" },
        { id: 17, name: "Nayarit", short: "Nay" },
        { id: 18, name: "Nuevo León", short: "NL" },
        { id: 19, name: "Oaxaca", short: "Oax" },
        { id: 20, name: "Puebla", short: "Pue" },
        { id: 21, name: "Querétaro", short: "Qro" },
        { id: 22, name: "Quintana Roo", short: "QR" },
        { id: 23, name: "San Luis Potosí", short: "SLP" },
        { id: 24, name: "Sinaloa", short: "Sin" },
        { id: 25, name: "Sonora", short: "Son" },
        { id: 26, "name": "Tabasco", short: "Tab" },
        { id: 27, name: "Tamaulipas", short: "Tamps" },
        { id: 28, name: "Tlaxcala", short: "Tlax" },
        { id: 29, name: "Veracruz", short: "Ver" },
        { id: 30, name: "Yucatán", short: "Yuc" },
        { id: 31, name: "Zacatecas", short: "Zac" },
      ],
      eventTypes: [
        "Screening + Talk",
        "Press Conference",
        "Screening + Q&A",
        "Workshop",
        "Performance",
        "Masterclass",
        "Meeting",
        "Opening",
        "Session",
        "Screening + Mediation",
        "Side B: Film Meetings",
        "Must-See",
        "Documentary Theater",
        "Panel",
      ],
    },
  },

  "es-MX": {
    gira: {
      programacion: 'Programación',
      calendario: 'Calendario',
      publicaciones: 'Publicaciones',
      tvTour: 'En televisión',
      onlineTour: 'Gira en línea'
    },
    blog:{
      backToTop:"Volver arriba",
      next:"Siguiente",
      previous:"Anterior",
      theme:"Temáticas",
      publicationType:"Tipo de publicación",
      news:"Noticias",
      viewAll:"Ver todas",
      reviews:"Reseñas",
      note:"Nota",
      clearFilters:"Limpiar filtros",
      viewAllPublications:"Ver todas las publicaciones",
      searchResults:"Resultados de búsqueda",
    },
    calendar: {
      back: "← Atrás",
      home: "Inicio",
      calendar: "Calendario",
      today: "Hoy",
      eventsIn: "Eventos en ",
      filterBy: "Filtrar por:",
      states: "Estados",
      eventType: "Tipo de Evento",
      clearFilters: "Limpiar filtros",
      backToTop: "Volver arriba",
      filters: "Filtros",
      searchEvents: "Buscar eventos",
      projection: "Proyección",
      onlineTour: "Gira en línea",
      tvScreening: "Proyección en tv",
      noState: "Sin Estado",
      months: [
        { id: 0, name: "Enero", short: "Ene" },
        { id: 1, name: "Febrero", short: "Feb" },
        { id: 2, name: "Marzo", short: "Mar" },
        { id: 3, name: "Abril", short: "Abr" },
        { id: 4, name: "Mayo", short: "May" },
        { id: 5, name: "Junio", short: "Jun" },
        { id: 6, name: "Julio", short: "Jul" },
        { id: 7, name: "Agosto", short: "Ago" },
        { id: 8, name: "Septiembre", short: "Sep" },
        { id: 9, name: "Octubre", short: "Oct" },
        { id: 10, name: "Noviembre", short: "Nov" },
        { id: 11, name: "Diciembre", short: "Dic" },
      ],
      mexicanStates: [
        { id: 0, name: "Aguascalientes", short: "Ags" },
        { id: 1, name: "Baja California", short: "BC" },
        { id: 2, name: "Baja California Sur", short: "BCS" },
        { id: 3, name: "Campeche", short: "Camp" },
        { id: 4, name: "Chiapas", short: "Chia" },
        { id: 5, name: "Chihuahua", short: "Chih" },
        { id: 6, name: "Ciudad de México", short: "CDMX" },
        { id: 7, name: "Coahuila", short: "Coah" },
        { id: 8, name: "Colima", short: "Col" },
        { id: 9, name: "Durango", short: "Dgo" },
        { id: 10, name: "Estado de México", short: "EdoMex" },
        { id: 11, name: "Guanajuato", short: "Gto" },
        { id: 12, name: "Guerrero", short: "Gro" },
        { id: 13, name: "Hidalgo", short: "Hgo" },
        { id: 14, name: "Jalisco", short: "Jal" },
        { id: 15, name: "Michoacán", short: "Mich" },
        { id: 16, name: "Morelos", short: "Mor" },
        { id: 17, name: "Nayarit", short: "Nay" },
        { id: 18, name: "Nuevo León", short: "NL" },
        { id: 19, name: "Oaxaca", short: "Oax" },
        { id: 20, name: "Puebla", short: "Pue" },
        { id: 21, name: "Querétaro", short: "Qro" },
        { id: 22, name: "Quintana Roo", short: "QR" },
        { id: 23, name: "San Luis Potosí", short: "SLP" },
        { id: 24, name: "Sinaloa", short: "Sin" },
        { id: 25, name: "Sonora", short: "Son" },
        { id: 26, name: "Tabasco", short: "Tab" },
        { id: 27, name: "Tamaulipas", short: "Tamps" },
        { id: 28, name: "Tlaxcala", short: "Tlax" },
        { id: 29, name: "Veracruz", short: "Ver" },
        { id: 30, name: "Yucatán", short: "Yuc" },
        { id: 31, name: "Zacatecas", short: "Zac" },
      ],
      eventTypes: [
        "Función + Conversatorio",
        "Conferencia de prensa",
        "Función + Q&A",
        "Taller",
        "Performance",
        "Clase Magistral",
        "Encuentro",
        "Inauguración",
        "Jornada",
        "Función + Mediación",
        "Lado B: Encuentros fílmicos",
        "Imperdible",
        "Teatro documental",
        "Mesa",
      ],
    },
    filter:{
      clear:"Limpiar",
      searchFilter:"Buscar filtros",
    },
    navbar: {
      nosotros: { label: "Nosotros" },
      programas: { label: "Programas" },
      calendario: { label: "Calendario" },
      películas: { label: "Películas" },
      blog: { label: "Blog" },
      aliados: { label: "Aliados" }
    },
    search: {
      viewAllResults: "Ver todos los resultados",
      noResults: "No existen películas que contengan '{{query}}'",
      tryAgain: "Intenta de nuevo con otro nombre",
      placeholder: "Busca películas por título o realizador/a",
      placeHolderPublicaciones:"Buscar publicaciones por título o autor",
    },
    movies: {
      about: "Sobre",
      viewAll: "Ver todas"
    },
    equipo:{
      team:"Equipo",
      share:"Compartir",
    },
      initiatives: {
      gira: {
        title: "Gira de Documentales",
        description: "Nuestra Gira de cine itinerante"
      },
      presenta: {
        title: "Presenta",
        description: "Circuito de exhibición de cine documental desde el quehacer colaborativo"
      },
      'mas-alla':{
        title:"Más Allá",
        description:"Capacitación en producción documental",
      },
      ediciones: {
        title:"Ediciones",
        description:"Obras para expandir la cultura del cine",

      },
      vivero: {
        title: "Vivero",
        description: "Formación en prácticas documentales audiovisuales",
        convocatoria: "Convocatoria",
        quotesTitle:"Vivero",
        quotesSubtitle:"prueba sub titulo",
        editionsTitle:"Ediciones",
        catalogue: "Catálogo",
      },
    common: {
      now: "Ahora",
      seeAllPrograms: "Ver todos los programas",
       allPrograms: "Todos los programas",
       programsSection: "Por programas",
	   programasAmbulante: "Programas Ambulante",
    },
  },
  common:{
    viewMoreDetails:"Ver más detalles",
      sobre:"Sobre",
      viewDetails:"Ver detalles",
      prensa:"Prensa",
      now: "Ahora",
      seeAllPrograms: "Ver todos los programas",
      allPrograms: "Todos los programas",
      programsSection: "Por programas",
      readMore: "Leer más",
      back:"Atras",
      contraloria:"Contraloría Social",
      vacantes:"Vacantes",
      year: "Año",
      country: "País",
      tourEditions: "Ediciones Gira",
      sections: "Secciones",
      generations: "Generaciones",
      apEditions: "Ediciones AP",
      productionYear: "Año de producción",
      allPrograms: "Todos los programas",
      documentaryTour: "Gira de Documentales",
      ambulanteBeyond: "Ambulante Más Allá",
      searchFilters: "Buscar filtros",
      clear: "Limpiar",
      applyFilters: "Aplicar filtros",
      filters: "Filtros",
      programs: "Programas",
      generationsAndDocumentaries: "Generaciones y sus documentales",
      directedBy: "Dirigido por:",
      createdBy: "Creado por:",
      viewAmaCollection: "Ver toda la colección de AMA",
      behindTheScenes: "Detrás de cámaras",
      theExperience: "La experiencia",
      beyondTheDocumentary: "Más Allá del documental",
      applyNow: "Postular ahora",
      downloadCatalog: "Descargar catálogo",
      subscribe: "Suscribir",
      noSpam: "No te enviaremos SPAM, solo noticias de las próximas convocatorias",
      faq: "Preguntas frecuentes",
    quotationMarks: "Comillas",

  },
  breadcrumbs: {
      Home: "Inicio",
      Blog: "Blog",
      catalog:"Catalogo",
      programs: "Programas",
      initiatives: "Programas",
    },
    footer: {
      forYou: "PARA TI",
      movies: "Películas",
      calendar: "Calendario",
      pressCenter: "Centro de prensa",
      programs: "PROGRAMAS",
      tour: "Gira Ambulante",
      beyond: "Ambulante Más Allá",
      presents: "Ambulante Presenta",
      editions: "Ambulante Ediciones",
      information: "INFORMACIÓN",
      directory: "Directorio",
      privacy: "Aviso de Privacidad",
      socialControl: "Contraloría Social",
      vacancies: "Vacantes",
      contact: "Contáctanos",
      newsletter: "Suscríbete al newsletter",
      address: "Zacatecas 142-A, Roma Norte, Cuauhtémoc, C.P. 06700, Ciudad de México",
      copyright: "© 2024 Ambulante. Todos los derechos reservados"
    },
    Aliados:{
      navigationAliados:"Patrocinadores Archivo - Ambulante",
      title:"Aliados",
      estado:"Estado",
      programas:"Programas",
      clearFilters: "Limpiar filtros",
    },
    AmbulanteEdiciones: {
      navigationEdiciones: "Ambulante Ediciones",
      title:"Ambulante Ediciones",
      libros: "Libros",
      Book: {
        publishedIn: "Publicado en",
        authors: "Autor(es)",
        synopsis: "Sinopsis",
        makeOrder: "Hacer pedido"
      },
      Magazine: {
        title: "Ambulante, la revista",
        download: "Descargar revista"
      }
    },
    AmbulanteMasAlla: {
      navigationMasAlla: " Ambulante Más Allá",
      announcementBanner: "¿Quieres ser parte de la 8va generación de Ambulante Más Allá? 🎥",
      announcementBannerSub: "🎬 ¡Conoce más aquí!",
      vimeo: "Te recomendamos ver los tráilers en nuestro canal de Vimeo",
      write: "y escribirnos a",
    },
    AmbulantePresenta: {
      titleSeo: "Ambulante Presenta - Ambulante",
      title: "Ambulante Presenta",
      materialesDescargables: "Materiales Descargables AP 2025",
      materialesDescargablesAnt: "Materiales Descargables (ediciones anteriores)",
      testimonialsTitle: "El cine documental",
      testimonialsSubtitle: "al alcance de todes",
    },
    Partners: {
      textHeadline: " ¡Muchas gracias",
      textHeadline2: "a nuestros colaboradores!",
    },
    GiraDocumentales: {
      breadcrumbs: "Gira de Documentales",
      historico: "Histórico de películas programadas",
      buttonCatalogo: "Ver todo el catálogo",
      testimonials: {
        title: "Un encuentro",
        subtitle: "emocionante y significativo",
      },
    },
    RelatedContent: {
      title: "Contenido relacionado",
      AnchorChip: {
        publications: "Publicaciones",
        films: "Películas",
        screenings: "Proyecciones",
        events: "Eventos",
      },
      Blogposter:{
        note:"Nota",
        news:"Noticia",
      },
    },
    FeaturedTitleCustom: {
      Button:"Ver detalles",
    },
    Films:{
      today:"Exhibiéndose hoy",
      calendario:"Ir a calendario",
    },
    Cards:{
      post:"Ir a la publicación",
    },
    Peditions: {
      pastEditions: "Ediciones anteriores",
      downloadPrograms: "Descargar programas",
      seeFilmCatalogue: "Ver catálogo de películas",
    },
    searchResults: "Resultados de búsqueda",
    verTodasPeliculas: "Ver todas las películas",
    movieCatalogT: "Explora los títulos que han pasado por Ambulante",
    compartir: "Compartir",
    aboutus: "Sobre nosotros",
    gira: "Gira",
    expMT: "Conoce las películas que han pasado por Ambulante",
    expMSub: "Descrubre por temáticas, años, países y más",
    btnExpC: "Explora el catálogo",
    mision: "Nuestra misión es movilizar espacios de encuentro y acción colectiva para construir otros mundos a través del documental. Conoce cómo lo hacemos.",
    nuestrosP: "Nuestros programas",
    atras: "← Atrás",
    inicio: "Inicio",
    programas: "Programas",
    por: "Por",
    volver: "Volver arriba",
    sinopsis: "Sinopsis",
    semblanza: "Semblanza",
    festivales: "Festivales y Premios",
    duracion: "Duracion",
    paises: "Paises",
    ano: "Año",
    idiomas: "Idiomas",
    direccion: "Direccion",
    tematicas: "Tematicas",
    iniciativas: "iniciativas",
    Mcreditos: "Mostrar Créditos",
    Ocreditos: "Ocultar Créditos",
    descargas: "Descargas",
    vtrailer: "Ver Trailer",
  },
};

// Add fallback to Spanish if needed
export const getLocaleTexts = (locale) => {
  return localeTexts[locale] || localeTexts.es;
};